import { Trash2Icon, X } from "lucide-react";
import React, { useState, useRef, useEffect } from "react";
import { FaTrash } from "react-icons/fa";
import { FaPencil } from "react-icons/fa6";
import { Outlet, Link, useLocation, useNavigate } from "react-router-dom";
import Swal from 'sweetalert2';
import Sidebar from "../../components/Sidebar";


function AdminLayout() {

  const [openMenus, setOpenMenus] = useState({ master: false,beranda: true });

  const toggleMenu = (menuName) => {
    setOpenMenus((prev) => ({ ...prev, [menuName]: !prev[menuName] }));
  };
  const [sidebarOpen, setSidebarOpen] = useState(false);
  const [dropdownOpen, setDropdownOpen] = useState(false);
  const dropdownRef = useRef(null);
  const navigate = useNavigate();
  const [loading, setLoading] = useState(true);
  const [whyUsReason, setWhyUsReason] = useState([]);
  const [addWhyUsReason, setAddWhyUsReason] = useState(null);
  const [formhyUsReason, setFormWhyUsReason] = useState(null);
  const [editId, setEditId] = useState(null);
  
  const [formDataWhyUsReason, setFormDataWhyUsReason] = useState({ title: '', description: '' , image:''});

  const handleAdd = (event) => {
    setAddWhyUsReason(event);
    setFormDataWhyUsReason({ title: event.title, description: event.description, image:event.iamge  });
  };

  const [whyUs, setWhyUs] = useState({
    title: "",
    description: "",
    gif: "", 
  });

  const [videoFile, setVideoFile] = useState(null);
  const [videoFileWhyUs, setVideoFileWhyUs] = useState(null);

  const fetchWhyUs = async () => {

    try {
        const res = await fetch(
            `${process.env.REACT_APP_BASE_URL}api/whyus/1`
        );

        if (!res.ok) throw new Error(`HTTP error! status: ${res.status}`);

        const json = await res.json();
        setWhyUs(json.data || []);

    } catch (err) {
        console.error("Fetch Pc error:", err);
    }
  };

  useEffect(() => {
    fetchWhyUs();
  }, []);

  const fetchWhyUsReason = async () => {
    try {
      const res = await fetch(`${process.env.REACT_APP_BASE_URL}api/whyusreason`);

      if (!res.ok) {
        throw new Error(`HTTP error! status: ${res.status}`);
      }

      const note = await res.json();
      const list = Array.isArray(note) ? note : note.data || [];

      setWhyUsReason(list);
    } catch (err) {
      console.error("Gagal mengambil data:", err);
    }
  };
  
  useEffect(() => {
    fetchWhyUsReason();
  }, []);

  const location = useLocation();
  const pageTitles = {
    "/": "Form Ajuan",
    "/admin/": "Halaman Admin",
    "/dashboard": "Dashboard",
    "/profile": "Profile",
    "/events": "Master Data Event",
    "/vendors": "Master Data Vendor",
    "/approval": "Master Data Approval",
    "/bank": "Master Data Akun Bank",
    "/account": "Pengaturan Akun",
    "/filteredRf": "Hasil Filter Tanggal",
    "/updateRf/": "Update Ajuan",
  };

  const isActive = (path) => {
    return location.pathname === path;
  };

  const updateWhyUs = async (e) => {
    e.preventDefault();
    setLoading(true);

    try {
      const formData = new FormData();

      // append text fields
      formData.append("title", whyUs.title);
      formData.append("description", whyUs.description);

      // append video jika ada
      if (videoFileWhyUs) {
        formData.append("video", videoFileWhyUs);
      }

      const res = await fetch(
        `${process.env.REACT_APP_BASE_URL}api/whyus/1`,
        {
          method: "POST",
          body: formData, // 
        }
      );

      if (!res.ok) throw new Error("Gagal update");

      const result = await res.json();

      Swal.fire({
        toast: true,
        position: "top-end",
        icon: "success",
        title: "Card berhasil diperbarui!",
        showConfirmButton: false,
        timer: 3000,
      });

    } catch (err) {
      Swal.fire("Error", "Gagal update data", "error");
    } finally {
      setLoading(false);
    }
  };

  const onChangeWhyUs = (e) => {
    const { name, value } = e.target;

    setWhyUs((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const onChangeWhyUsVideo = (e) => {
    const file = e.target.files[0];

    if (file) {    
      setVideoFileWhyUs(file);
    }
  };

  const handleEditClick = (item) => {
    setEditId(item.id);

    setFormDataWhyUsReason({
      title: item.title,
      description: item.description,
      image: null, // kosongkan dulu file upload
    });

    setAddWhyUsReason(true); // buka modal
  };

  const handleInsert = async (e) => {
    e.preventDefault();

    try {
      const formData = new FormData();
      formData.append("title", formDataWhyUsReason.title);
      formData.append("description", formDataWhyUsReason.description);
      formData.append("image", formDataWhyUsReason.image);

      const response = await fetch(`${process.env.REACT_APP_BASE_URL}api/whyusreason/insert`, {
        method: "POST",
        body: formData,
      });

      const result = await response.json();

      if (response.ok) {

        // Reset form
        setFormDataWhyUsReason({
          title: "",
          description: "",
          image: "",
        });

        setAddWhyUsReason(null);
        await fetchWhyUsReason();
        Swal.fire({
          toast: true,
          position: "top-end",
          icon: "success",
          title: "Card berhasil ditambahkan!",
          showConfirmButton: false,
          timer: 3000,
        });
      } else {
        alert(result.message || "Gagal menyimpan data");
      }
    } catch (error) {
      console.error(error);
      alert("Terjadi kesalahan");
    }
  };
  
  const handleDelete = (id) => {
    Swal.fire({
      title: 'Yakin hapus Card ini?',
      icon: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#d33',
      cancelButtonColor: '#3085d6',
      confirmButtonText: 'Ya, hapus',
      cancelButtonText: 'Batal',
    }).then((result) => {
      if (result.isConfirmed) {
        fetch(`${process.env.REACT_APP_BASE_URL}api/whyusreason/${id}`, {
          method: 'DELETE',
        })
          .then((res) => res.json())
          .then(() => {
            Swal.fire('Terhapus!', 'Data berhasil dihapus.', 'success');
            fetchWhyUsReason();
          });
      }
    });
  };

  const handleUpdate = async (e) => {
    e.preventDefault();

    try {
      const formData = new FormData();
      formData.append("title", formDataWhyUsReason.title);
      formData.append("description", formDataWhyUsReason.description);

      // hanya kirim icon jika ada file baru
      if (formDataWhyUsReason.image) {
        formData.append("image", formDataWhyUsReason.image);
      }

      const response = await fetch(
        `${process.env.REACT_APP_BASE_URL}api/whyusreason/update/${editId}`,
        {
          method: "POST", // CI4 biasanya POST untuk update
          body: formData,
        }
      );

      const result = await response.json();

      if (response.ok) {

        await fetchWhyUsReason(); // refresh data
        
        setAddWhyUsReason(null);
        await fetchWhyUsReason();
        Swal.fire({
          toast: true,
          position: "top-end",
          icon: "success",
          title: "Card berhasil diupdate!",
          showConfirmButton: false,
          timer: 3000,
        });
      } else {
        alert(result.message || "Gagal update");
      }
    } catch (error) {
      console.error(error);
      alert("Terjadi kesalahan");
    }
  };

  return (
    <div className="min-h-screen bg-slate-950 text-white pt-20">
      {/* Header Section */}
      <section 
        data-section="header"
        className="py-24 bg-gradient-to-b from-slate-900 to-slate-950 relative overflow-hidden"
      >
        <div className="absolute inset-0">
          <img
            src="/images/bg-hero-about-us.jpeg"
            alt="background"
            className="w-full h-full object-cover opacity-20"
          />
        </div>

        <div className={`relative max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center transition-all duration-1000 opacity-100 translate-y-0
        }`}>
          <h1 className="font-bricolage text-5xl md:text-6xl font-bold mb-6 bg-gradient-to-r from-blue-400 to-red-400 bg-clip-text text-transparent">
            Halaman Admin
          </h1>
          <div className="w-24 h-1 bg-gradient-to-r from-blue-500 to-red-500 mx-auto mb-6"></div>
        </div>
      </section>
      <section 
        data-section="contact"
        className="py-24 bg-slate-950"
      >
        <div className='flex flex-row max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 transition-all duration-1000 delay-200'>
          <div className='w-1/4'>
            <Sidebar></Sidebar>
          </div>
          <div className='w-3/4 p-4 bg-gray-800 text-white flex-col md:relative md:flex rounded-3xl '>
            <div className='flex flex-col'>
              <div className='p-4 text-xl font-medium'>
                Section Kenapa memilih Radar
              </div>
              <div className='flex flex-row'>
                <div className='w-1/3 p-4'>
                  <label className="block mb-1 font-medium ">Title</label>
                  <input
                    type="text"
                    name="title"
                    className="w-full text-black border px-3 py-2 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500"
                    value={whyUs?.title}
                    onChange={onChangeWhyUs}
                    required
                  />
                </div>
                <div className='w-1/3 p-4'>
                  <label className="block mb-1 font-medium ">Description</label>
                  <textarea
                  name='description'
                    className="w-full text-black border px-3 py-2 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500"
                    value={whyUs?.description}
                    onChange={onChangeWhyUs}
                    required
                    rows={4}
                  />
                </div>
                <div className='w-1/3 p-4'>
                  <label className="block mb-1 font-medium ">Video Tengah</label>
                  <input
                    type="file"
                    accept="video/*"
                    onChange={onChangeWhyUsVideo}
                    className="block w-full text-sm file:mr-4 file:py-2 file:px-4
                    file:rounded-md file:border-0
                    file:bg-blue-600 file:text-white
                    hover:file:bg-blue-700 mb-4"
                  />  
                </div>
              </div>
              <div className='flex flex-row'>
                <div className='w-1/3 p-4'>
                  <button onClick={updateWhyUs} className='p-4 rounded-full bg-gradient-to-r from-blue-600/30 to-red-600/30 hover:shadow-xl hover:shadow-blue-500/50 transform hover:scale-105 transition-all duration-300'>Simpan</button>
                </div>
              </div>
            </div>
            <div className='flex flex-col'>
              <div className='p-4 text-xl font-medium'>
                List Card kenapa memilih Radar
              </div>
              <div className='flex flex-row p-4'>
                <table class="min-w-full divide-y divide-gray-200 bg-gradient-to-b from-slate-900 to-slate-950 text-gray-400">
                  <thead class="font-bricolage font-bold mb-4 bg-gradient-to-r from-blue-400 to-red-400  text-transparent">
                    <tr>
                      <th class="p-4 font-medium text-gray-900 text-center">Title</th>
                      <th class="p-4 font-medium text-gray-900 text-center">Description</th>
                      <th class="font-medium text-gray-900 text-center">Icon</th>
                      <th class="font-medium text-gray-900 text-center">Action</th>
                    </tr>
                  </thead>
                  <tbody class="divide-y divide-gray-200">
                    {Array.isArray(whyUsReason) && whyUsReason.map((a, idx) => (
                      <>
                        <tr class="hover:bg-gray-500">
                          <td class="p-4 text-white text-center">{a.title}</td>
                          <td class="p-4 text-white text-center">{a.description}</td>
                          <td class="p-4 text-white text-center">
                            <img className='max-h-64' src={`${process.env.REACT_APP_BASE_URL}uploads/images/${a.image}`} />
                          </td>
                          <td class="p-4 text-white text-center">
                            <div className='flex flex-row gap-4 items-center justify-center'>
                              <FaPencil onClick={() => handleEditClick(a)} className='cursor-pointer'></FaPencil> 
                              <FaTrash onClick={() => handleDelete(a.id)} className='cursor-pointer'></FaTrash>
                            </div>
                          </td>
                        </tr>
                      </>
                      ))
                    }
                  </tbody>
                </table>
              </div>
              <div className='flex flex-row'>
                <div className='w-1/3 p-4'>
                  <button onClick={handleAdd} className='p-4 rounded-full bg-gradient-to-r from-blue-600/30 to-red-600/30 hover:shadow-xl hover:shadow-blue-500/50 transform hover:scale-105 transition-all duration-300'>Tambah</button>
                </div>
              </div>
            </div>
          </div>
          
        </div>
      </section>
      {addWhyUsReason && (
        <div
          className="fixed inset-0 bg-black/60 backdrop-blur-sm flex justify-center items-center z-50 p-4"
          onClick={() => {
            setAddWhyUsReason(null);
            setEditId(null);
          }}
        >
          <div
            className="bg-white text-black p-6 rounded-2xl w-full max-w-md relative shadow-2xl max-h-[90vh] overflow-y-auto"
            onClick={(e) => e.stopPropagation()}
          >
            {/* Close Button */}
            <button
              className="absolute top-3 right-3 text-gray-500 hover:text-red-500 transition"
              onClick={() => {
                setAddWhyUsReason(null);
                setEditId(null);
              }}
            >
              <X size={20} />
            </button>

            {/* Title */}
            <h3 className="text-xl font-bold mb-6 text-center">
              {editId
                ? "Edit Card Kenapa Memilih Radar"
                : "Tambah Card Kenapa Memilih Radar"}
            </h3>

            {/* Form */}
            <form
              onSubmit={editId ? handleUpdate : handleInsert}
              className="space-y-4"
            >
              {/* Title */}
              <div>
                <label className="block font-medium mb-1">Title</label>
                <input
                  type="text"
                  value={formDataWhyUsReason.title}
                  onChange={(e) =>
                    setFormDataWhyUsReason({
                      ...formDataWhyUsReason,
                      title: e.target.value,
                    })
                  }
                  className="w-full border border-gray-300 p-2 rounded-lg focus:ring-2 focus:ring-blue-500 outline-none"
                  required
                />
              </div>

              {/* Description */}
              <div>
                <label className="block font-medium mb-1">Description</label>
                <textarea
                  rows="3"
                  value={formDataWhyUsReason.description}
                  onChange={(e) =>
                    setFormDataWhyUsReason({
                      ...formDataWhyUsReason,
                      description: e.target.value,
                    })
                  }
                  className="w-full border border-gray-300 p-2 rounded-lg focus:ring-2 focus:ring-blue-500 outline-none"
                />
              </div>

              {/* Icon Upload */}
              <div>
                <label className="block font-medium mb-1">Icon</label>
                <input
                  type="file"
                  accept="image/*"
                  onChange={(e) =>
                    setFormDataWhyUsReason({
                      ...formDataWhyUsReason,
                      image: e.target.files[0],
                    })
                  }
                  className="w-full border border-gray-300 p-2 rounded-lg"
                />
                
                <span className='text-sm text-red-600'><i>*rekomendasi file type: .png</i></span>

                {/* Preview Image */}
                {formDataWhyUsReason.image && (
                  <img
                    src={URL.createObjectURL(formDataWhyUsReason.image)}
                    alt="preview"
                    className="mt-3 h-20 object-contain rounded-lg border"
                  />
                )}
              </div>

              {/* Buttons */}
              <div className="flex justify-end gap-3 pt-4">
                <button
                  type="button"
                  className="px-4 py-2 bg-gray-200 rounded-full hover:bg-gray-300 transition"
                  onClick={() => {
                    setAddWhyUsReason(null);
                    setEditId(null);
                  }}
                >
                  Batal
                </button>

                <button
                  type="submit"
                  className="px-6 py-2 rounded-full bg-gradient-to-r from-blue-600 to-red-600 text-white hover:shadow-lg transform hover:scale-105 transition-all duration-300"
                >
                  {editId ? "Update" : "Simpan"}
                </button>
              </div>
            </form>
          </div>
        </div>
      )}
    </div>
  );
}

export default AdminLayout;
